module.exports = __webpack_public_path__ + "img/r@2x.ef7abd76.jpg";